<template>
    <div class="login-form">
        <div class="login-form__title">
            {{ $t('login.reset.title') }}
        </div>
        <form class="form" @submit.prevent="changePassword">
            <div class="login-form__row">
                <FormInput
                    ref="password"
                    v-model="password1"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.password')"
                    :type="showPass ? 'text' : 'password'"
                    required
                    @focus="error = null"
                >
                    <template #prepend>
                        <span v-tooltip="helpText">
                            <svg
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.5651 8.80983C14.3584 8.60318 14.1076 8.50002 13.8124 8.50002H5.66661V4.95839C5.66661 4.17614 5.94336 3.50848 6.49678 2.95506C7.05024 2.40176 7.71793 2.12505 8.50011 2.12505C9.2822 2.12505 9.95002 2.40172 10.5032 2.95506C11.0567 3.50848 11.3335 4.17618 11.3335 4.95839C11.3335 5.15017 11.4035 5.31616 11.5436 5.45634C11.6839 5.59655 11.85 5.66668 12.0416 5.66668H12.7503C12.942 5.66668 13.1079 5.59655 13.2483 5.45634C13.3881 5.31616 13.4584 5.15017 13.4584 4.95839C13.4584 3.59322 12.9733 2.4258 12.0031 1.45545C11.0328 0.485074 9.86508 0 8.50011 0C7.13502 0 5.96739 0.485074 4.99701 1.45542C4.02679 2.42564 3.54167 3.59318 3.54167 4.95835V8.49998H3.18755C2.8925 8.49998 2.64157 8.60337 2.43495 8.8098C2.22833 9.01622 2.12506 9.26723 2.12506 9.56239V15.9375C2.12506 16.2328 2.22837 16.4836 2.43495 16.6902C2.64157 16.8966 2.8925 17 3.18755 17H13.8124C14.1076 17 14.3586 16.8966 14.5651 16.6902C14.7715 16.4836 14.875 16.2328 14.875 15.9375V9.56243C14.8751 9.26727 14.7718 9.01653 14.5651 8.80983Z"
                                    fill="#D8D8E1"
                                />
                            </svg>
                        </span>
                    </template>
                    <template #append>
                        <button
                            class="button button--blank login-form__show-pass-button"
                            type="button"
                            tabindex="-1"
                            @click="toggleShowPass"
                        >
                            <svg
                                width="20"
                                height="20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click.prevent
                            >
                                <g clip-path="url(#clip0)">
                                    <path
                                        d="M10 4.04c-3.821 0-7.286 2.09-9.844 5.485a.792.792 0 000 .945c2.558 3.4 6.023 5.49 9.844 5.49 3.821 0 7.287-2.09 9.843-5.485a.792.792 0 000-.945C17.287 6.13 13.821 4.04 10 4.04zm.274 10.158a4.21 4.21 0 01-4.472-4.472 4.216 4.216 0 013.924-3.924 4.209 4.209 0 014.472 4.472 4.23 4.23 0 01-3.924 3.924zm-.127-1.94a2.261 2.261 0 01-2.405-2.405 2.275 2.275 0 012.115-2.115 2.261 2.261 0 012.405 2.405 2.275 2.275 0 01-2.115 2.115z"
                                        fill="#D8D8E1"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <path fill="#fff" d="M0 0h20v20H0z" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </template>
                </FormInput>
            </div>
            <div class="login-form__row">
                <FormInput
                    ref="password"
                    v-model="password2"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.reset.password2')"
                    :type="showPass ? 'text' : 'password'"
                    required
                    @focus="error = null"
                >
                    <template #prepend>
                        <span v-tooltip="helpText">
                            <svg
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.5651 8.80983C14.3584 8.60318 14.1076 8.50002 13.8124 8.50002H5.66661V4.95839C5.66661 4.17614 5.94336 3.50848 6.49678 2.95506C7.05024 2.40176 7.71793 2.12505 8.50011 2.12505C9.2822 2.12505 9.95002 2.40172 10.5032 2.95506C11.0567 3.50848 11.3335 4.17618 11.3335 4.95839C11.3335 5.15017 11.4035 5.31616 11.5436 5.45634C11.6839 5.59655 11.85 5.66668 12.0416 5.66668H12.7503C12.942 5.66668 13.1079 5.59655 13.2483 5.45634C13.3881 5.31616 13.4584 5.15017 13.4584 4.95839C13.4584 3.59322 12.9733 2.4258 12.0031 1.45545C11.0328 0.485074 9.86508 0 8.50011 0C7.13502 0 5.96739 0.485074 4.99701 1.45542C4.02679 2.42564 3.54167 3.59318 3.54167 4.95835V8.49998H3.18755C2.8925 8.49998 2.64157 8.60337 2.43495 8.8098C2.22833 9.01622 2.12506 9.26723 2.12506 9.56239V15.9375C2.12506 16.2328 2.22837 16.4836 2.43495 16.6902C2.64157 16.8966 2.8925 17 3.18755 17H13.8124C14.1076 17 14.3586 16.8966 14.5651 16.6902C14.7715 16.4836 14.875 16.2328 14.875 15.9375V9.56243C14.8751 9.26727 14.7718 9.01653 14.5651 8.80983Z"
                                    fill="#D8D8E1"
                                />
                            </svg>
                        </span>
                    </template>
                    <template #append>
                        <button
                            class="button button--blank login-form__show-pass-button"
                            type="button"
                            tabindex="-1"
                            @click="toggleShowPass"
                        >
                            <svg
                                width="20"
                                height="20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click.prevent
                            >
                                <g clip-path="url(#clip0)">
                                    <path
                                        d="M10 4.04c-3.821 0-7.286 2.09-9.844 5.485a.792.792 0 000 .945c2.558 3.4 6.023 5.49 9.844 5.49 3.821 0 7.287-2.09 9.843-5.485a.792.792 0 000-.945C17.287 6.13 13.821 4.04 10 4.04zm.274 10.158a4.21 4.21 0 01-4.472-4.472 4.216 4.216 0 013.924-3.924 4.209 4.209 0 014.472 4.472 4.23 4.23 0 01-3.924 3.924zm-.127-1.94a2.261 2.261 0 01-2.405-2.405 2.275 2.275 0 012.115-2.115 2.261 2.261 0 012.405 2.405 2.275 2.275 0 01-2.115 2.115z"
                                        fill="#D8D8E1"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <path fill="#fff" d="M0 0h20v20H0z" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </template>
                </FormInput>
            </div>

            <div class="form__row">
                <button :disabled="loading" class="button button--big login-form__button">
                    {{ $t('login.reset.submit') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { FormInput } from '@speechki-frontend/shared/ui/forms';
import { resetPassword, fetchResetPasswordHelpText } from '../../api';

export default {
    name: 'PasswordResetForm',
    components: {
        FormInput,
    },
    data() {
        return {
            password1: '',
            password2: '',
            showPass: false,
            error: null,
            loading: false,
            helpTextArray: null,
            uid: '',
            token: '',
        };
    },
    computed: {
        helpText() {
            if (!this.helpTextArray || !this.helpTextArray.detail) return '';
            return this.helpTextArray.detail.join('<br>');
        },
    },
    created() {
        if (this.$store.state.auth.user.pk) {
            this.$router.push('/');
        }

        const { uid, token } = this.$route.query;

        if (!uid || !token) {
            this.$router.push('/');
        }

        this.uid = uid;
        this.token = token;

        fetchResetPasswordHelpText('/rest-auth/password/help_text/').then(
            (res) => (this.helpTextArray = res)
        );
    },
    methods: {
        toggleShowPass() {
            this.showPass = !this.showPass;
        },
        async changePassword() {
            this.error = null;
            try {
                this.loading = true;

                await resetPassword({
                    new_password1: this.password1,
                    new_password2: this.password2,
                    uid: this.uid,
                    token: this.token,
                });

                this.$store.dispatch('pushToast', {
                    id: Date.now(),
                    type: 'success',
                    title: 'Password Reset',
                    text: 'Now you will be redirected to login page',
                });

                this.$router.push('/login');

                this.loading = false;
            } catch (e) {
                this.error = e;
                this.loading = false;
            }
        },
    },
};
</script>
